import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import {
  removeUploadFromShoppingCart,
  changeUploadQuantity,
} from 'gatsby-theme-kn/src/utils/media_database_shopping_cart'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const MediaDatabasePromotialOrderItem = ({
  item,
  setter,
  displaySetsRecursive,
}) => {
  const { t } = useTranslation()
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('media_engine/' + item[2] + 's/' + item[0] + '?v=1'),
    {},
    'get'
  )

  const showItem = function (data, setter, displaySetsRecursive) {
    if (displaySetsRecursive) {
      return (
        <li className="media-cart-list-item list-inline-item">
          <img
            className="img-fluid"
            src={data.urls.thumbnail}
            title={data.title}
            style={{ maxWidth: '80px', maxHeight: '80px' }}
          />
          <div className="media-cart-list-item-title" title={data.title}>
            {data.title}
          </div>
          {item[3] && (
            <div className="media-cart-list-item-subtitle" title="">
              {item[3]}
            </div>
          )}
          <span className="media-cart-list-item-count">
            <span className="media-cart-list-item-value">{item[1]}</span>x
          </span>
        </li>
      )
    } else {
      return (
        <li className="media-cart-list-item list-inline-item">
          <div style={{ display: 'block', maxWidth: '85px' }}>
            <img
              className="img-fluid"
              src={data.urls.thumbnail}
              title={data.title}
            />
          </div>
          <div className="media-cart-list-item-title" title={data.title}>
            {data.title}
          </div>
          <span className="media-cart-list-item-count">
            <span className="media-cart-list-item-value">{item[1]}</span>x
          </span>

          {setter && (
            <span className="media-cart-list-item-controls">
              <a
                className="control-remove"
                href="/"
                onClick={(e) => {
                  e.preventDefault()
                  removeUploadFromShoppingCart(item[0], setter)
                }}
              >
                <i className="far fa-times"></i>
              </a>

              <a
                className="control-plus"
                href="/"
                onClick={(e) => {
                  e.preventDefault()
                  changeUploadQuantity(item[0], 1, setter)
                }}
              >
                <i className="far fa-plus"></i>
              </a>

              <a
                className="control-minus"
                href="/"
                onClick={(e) => {
                  e.preventDefault()
                  changeUploadQuantity(item[0], -1, setter)
                }}
              >
                <i className="far fa-minus"></i>
              </a>
            </span>
          )}
        </li>
      )
    }
  }

  // Zuerst "displaySetsRecursive" bewerten
  if (displaySetsRecursive) {
    // bei einem Set-Artikel werden die einzelnen Uploads "darunter" angezeigt
    // => nur im Werbemittel-Bestellformular (wo oben auch die Adresse steht)
    if (item[2] == 'upload_set') {
      return (
        <>
          {data && (
            <>
              {data.uploads.map((i, index) => (
                <MediaDatabasePromotialOrderItem
                  item={[i.id, item[1], i.type, data.title]}
                  setter={setter}
                  displaySetsRecursive={displaySetsRecursive}
                />
              ))}
            </>
          )}
        </>
      )
    } else {
      return (
        <>
          {loading && <LoadingSpinner />}
          {data && <>{showItem(data, setter, displaySetsRecursive)}</>}
        </>
      )
    }
  } else {
    // "normale" Darstellung im Warenkorb unten
    return (
      <>
        {loading && <LoadingSpinner />}
        {data && <>{showItem(data, setter, displaySetsRecursive)}</>}
      </>
    )
  }
}

export default MediaDatabasePromotialOrderItem
